module.exports = __webpack_public_path__ + "img/ring_r_e_1_0.6580b274.png";